// Coffres - 5 raretés
// Les bonus de stats sont perdus quand le personnage meurt

export const CHEST_RARITIES = {
  bronze: {
    nom: "Bronze",
    couleur: "bg-amber-700",
    textColor: "text-white",
    borderColor: "border-amber-900",
    rangeBonus: { min: 1, max: 3 },
    nbStats: 1,
    goldRange: { min: 10, max: 30 },
    poids: 50,
  },
  argent: {
    nom: "Argent",
    couleur: "bg-slate-300",
    textColor: "text-slate-900",
    borderColor: "border-slate-400",
    rangeBonus: { min: 2, max: 5 },
    nbStats: 2,
    goldRange: { min: 25, max: 60 },
    poids: 28,
  },
  or: {
    nom: "Or",
    couleur: "bg-yellow-400",
    textColor: "text-slate-900",
    borderColor: "border-yellow-600",
    rangeBonus: { min: 4, max: 8 },
    nbStats: 3,
    goldRange: { min: 50, max: 100 },
    poids: 15,
  },
  legendaire: {
    nom: "Légendaire",
    couleur: "bg-fuchsia-500",
    textColor: "text-white",
    borderColor: "border-fuchsia-700",
    rangeBonus: { min: 7, max: 14 },
    nbStats: 4,
    goldRange: { min: 100, max: 200 },
    poids: 6,
  },
  prismatique: {
    nom: "Prismatique",
    couleur: "bg-gradient-to-br from-red-500 via-yellow-400 to-sky-500",
    textColor: "text-white",
    borderColor: "border-white",
    rangeBonus: { min: 12, max: 25 },
    nbStats: 5,
    goldRange: { min: 200, max: 400 },
    poids: 1,
  },
};

const STAT_KEYS = ["pv", "atk", "def", "vit", "crit", "degatsCrit", "degatsElem", "res", "precision"];

// Tire une rareté en fonction des poids (+ bonus étage)
export const rollChestRarity = (floor = 1, forcedRarity = null) => {
  if (forcedRarity) return forcedRarity;
  // Boost progressif pour les étages
  const floorMult = 1 + (floor - 1) * 0.15;
  const entries = Object.entries(CHEST_RARITIES);
  // Augmente les rares avec l'étage
  const adjusted = entries.map(([k, v]) => {
    let poids = v.poids;
    if (k === "prismatique" || k === "legendaire" || k === "or") poids *= floorMult;
    return [k, poids];
  });
  const total = adjusted.reduce((s, [, p]) => s + p, 0);
  let roll = Math.random() * total;
  for (const [k, p] of adjusted) {
    roll -= p;
    if (roll <= 0) return k;
  }
  return "bronze";
};

// Génère le contenu d'un coffre
import { rollItemFromChest } from "./items";

export const generateChestContent = (rarity) => {
  const config = CHEST_RARITIES[rarity];
  const stats = {};
  const usedKeys = new Set();
  // PV plus important : multiplier la valeur par 5
  for (let i = 0; i < config.nbStats; i++) {
    let key;
    do {
      key = STAT_KEYS[Math.floor(Math.random() * STAT_KEYS.length)];
    } while (usedKeys.has(key));
    usedKeys.add(key);
    let val = config.rangeBonus.min + Math.floor(Math.random() * (config.rangeBonus.max - config.rangeBonus.min + 1));
    if (key === "pv") val = val * 4;
    if (key === "degatsCrit") val = val * 3;
    stats[key] = val;
  }
  const gold = config.goldRange.min + Math.floor(Math.random() * (config.goldRange.max - config.goldRange.min + 1));
  // Drop d'un item (toujours, mais raretés différentes selon le coffre)
  const item = rollItemFromChest(rarity);
  return { rarity, stats, gold, item: item ? item.id : null };
};
